import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import { _fetchAssignedTimesheetList } from "@/services/timesheet";
import { formatTimesheets } from "@/utilities/dataFormatter";
import { handleAPICatch } from "@/utilities/utils";
const initialState = {
  isLoading: false,
  isPaginationLoading: false,
  assignedTimesheets: [],
  selectedCandidate: [], // list of candidate id
  selectedSignOffIds: [], // list of signoff ids
  selectedTimesheets: [],
  filters: {
    search: "",
    sessionType: [],
    candidateReferenceNo: "",
    contractReferenceNo: "",
    candidateId: [],
    candidateRole: null,
    complianceStatus: null,
    miles: null,
    candidateLicenseNo: "",
    candidatePostcode: "",
    workedDateFrom: "",
    workedDateTo: "",
    contractDateFrom: "",
    contractDateTo: "",
  },
  totalCount: 0,
  isSelectedAll: false,
  oldFilters: {},
  pagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  sorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
  showRejectModal: false,
  showAdjustAmendmentModal: false,
  adjustAmendMentData: {},
  showFilters: false,
  toggleSelected: false,
  showSignOffModal: false,
  selectedSignOffData: {},
};

export const fetchAssignedTimesheets = createAsyncThunk(
  "timesheetsAssigned/fetchAssignedTimesheets",
  async (data, { dispatch, getState }) => {
    const {
      timesheetAssigned: { filters, pagination, sorting, assignedTimesheets },
    } = getState();
    if (_.isEmpty(data)) {
      data = {
        ...filters,
      };
    }
    if (pagination.isLastPage) {
      return dispatch(setAssignedTimesheetsLoading(false));
    }

    dispatch(setPaginationLoading(pagination.currentPage !== 1));
    dispatch(toggleSelectedAll(false));

    const _data = {
      ...data,
      currentPage: pagination.currentPage,
      ...sorting,
      timesheetType: "assigned",
    };

    let response = _fetchAssignedTimesheetList(_data);
    response
      .then((res) => {
        const {
          data: { timesheet_list, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        let data = formatTimesheets(timesheet_list, 0);

        dispatch(
          updatePagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );

        let prevList = currentPage === 1 ? [] : _.uniq(assignedTimesheets);

        let firstsign_off_id = data.length > 0 ? data[0].sign_off_id : null;

        dispatch(updateTotalCount(totalCount));

        if (
          prevList.length > 0 &&
          prevList.find((item) => item.sign_off_id === firstsign_off_id) !==
            undefined
        ) {
          //
        } else {
          dispatch(updateAssignedTimesheets([...prevList, ...data]));
        }
        return res;
      })
      .catch((error) => {
        console.log("error-----ASSIGNED", error);
        handleAPICatch(error);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setAssignedTimesheetsLoading(false));
          dispatch(setPaginationLoading(false));
        }, 10);
      });
  },
);

const timesheetsAssignedSlice = createSlice({
  name: "timesheetsAssigned",
  initialState,
  reducers: {
    updateAssignedTimesheets: (state, action) => {
      state.assignedTimesheets = action.payload;
    },
    setAssignedTimesheetsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setPaginationLoading(state, action) {
      state.isPaginationLoading = action.payload; // New reducer for pagination loading
    },
    updateSelectedTimesheets: (state, action) => {
      state.selectedTimesheets = action.payload;
      if (action.payload.length === 0) {
        state.isSelectedAll = false;
      }
    },
    deSelectAllTimesheets: (state) => {
      state.selectedTimesheets = [];
      state.isSelectedAll = false;
    },
    updateFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.filters = {
          search: state.filters.search,
          ...initialState.filters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.filters = initialState.filters;
        } else {
          state.filters = { ...state.filters, ...action.payload };
        }
      }
    },
    updatePagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    updateSorting: (state, action) => {
      state.sorting = action.payload;
    },
    toggleRejectModal: (state, action) => {
      state.showRejectModal = action.payload;
    },
    toggleAdjustAmendmentModal: (state, action) => {
      state.showAdjustAmendmentModal = action.payload;
    },
    showFilterModal: (state, action) => {
      if (action.payload) {
        state.oldFilters = state.filters;
      }
      state.showFilters = action.payload;
    },
    updateToggleSelected: (state) => {
      state.toggleSelected = !state.toggleSelected;
    },
    reStateFilters: (state) => {
      state.filters = state.oldFilters;
    },
    updateTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    toggleSelectedAll: (state, action) => {
      state.isSelectedAll = action.payload;
    },
    toggleSignOffModal: (state, action) => {
      if (action.payload === undefined) {
        state.showSignOffModal = !state.showSignOffModal;
      } else {
        state.showSignOffModal = action.payload;
      }
    },
    toggleSignOffModalData: (state, action) => {
      state.selectedSignOffData = action.payload;
    },
  },
});

export const {
  updateAssignedTimesheets,
  setAssignedTimesheetsLoading,
  setPaginationLoading,
  deSelectAllTimesheets,
  updateFilters,
  updateSorting,
  updatePagination,
  toggleRejectModal,
  toggleAdjustAmendmentModal,
  showFilterModal,
  updateToggleSelected,
  reStateFilters,
  updateTotalCount,
  toggleSelectedAll,
  toggleSignOffModal,
  toggleSignOffModalData,
  updateSelectedTimesheets,
} = timesheetsAssignedSlice.actions;

export default timesheetsAssignedSlice.reducer;
